import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { $CurrentPOIInfoAsAvailable } from '@poi/shared/current-poi-info';
import { IImage } from 'shared/models/media';
import { useMemo } from 'react';
import { ArticleDetailUtil } from 'shared/models/article';
import { $CurrentPOIPosts } from '@poi/shared/current-poi-posts';

export const usePOILinkPreviewTitle = (): string => {
  const { t } = useTranslation();
  const poi = useAtomValue($CurrentPOIInfoAsAvailable);

  return t('share_poi_header').replace('{place}', poi.name);
};

export const usePOIDescription = (): string => {
  const { t } = useTranslation();
  return t('share_poi_body');
};

export const usePOICoverImage = (): IImage | null => {
  const hashtag = useAtomValue($CurrentPOIInfoAsAvailable);
  const { items: poiPosts } = useAtomValue($CurrentPOIPosts);

  return useMemo<IImage | null>(() => {
    const headerImage = hashtag.headerImage;
    if (headerImage) {
      return headerImage;
    }

    if (poiPosts.length) {
      return ArticleDetailUtil.getCoverImage(poiPosts[0]);
    }

    return null;
  }, [hashtag, poiPosts]);
};
